import axios from 'axios';
import { notistackRef } from '../utils/notistackRef';
import { pushErrorToast } from '../components/motion/errorToast';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

// Attach token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cloudToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// A 401 from these means wrong credentials or code, not an expired session; the page shows the error itself.
const CREDENTIAL_CHECKS = ['/api/auth/login', '/api/auth/mfa/verify'];

// Only the path decides: query strings and an absolute URL's origin are dropped before the exact match.
const requestPath = (config) => {
  try {
    return new URL(config?.url || '', 'http://local').pathname;
  } catch (_) {
    return null;
  }
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !CREDENTIAL_CHECKS.includes(requestPath(error.config))) {
      localStorage.removeItem('cloudToken');
      localStorage.removeItem('cloudUser');
      window.location.href = '/login';
    } else if (error.response?.status >= 500) {
      // Show server error toast
      const message = error.response?.data?.error || 'Server error: Please try again later';
      pushErrorToast(notistackRef.current, message);
    }
    return Promise.reject(error);
  }
);

export default api;
